import React, { useState } from 'react';
import { GridWrapper, StyledECardColumn, StyledECardColumns } from '@components/GalleryComponents/GalleryGrid/GalleryGrid.styles';
import { GalleryECardModal } from '@components/GalleryComponents/GalleryECardModal/GalleryECardModal';
import { PhotoECardModal } from '@components/GalleryComponents/PhotoECardModal/PhotoECardModal';
import { GalleryECardCell } from '@components/GalleryComponents/GalleryGrid/GalleryECardCell';
import { productTypes } from '@data-ts/components/GalleryComponents/GalleryPageContent';

const analytics = require('../../../../static/js/joy');
interface Props
  extends Readonly<{
    cards: MarketingData;
    productType: GalleryProductType;
    hasPhotoECards?: boolean;
  }> {}

export const GalleryGrid: React.FC<Props> = ({ cards, productType, hasPhotoECards }) => {
  const { designs } = productTypes;
  const [isDisplayCardDetails, setCardDetailModalToggle] = useState(false);
  const [cardDetails, setCardDetails] = useState<GalleryECard>({
    title: '',
    variationType: '',
    imageUrl: '',
    colors: [''],
    font: '',
    printUrl: '',
    tags: [''],
    vendor: '',
    productType,
    variantColor: '',
    variantName: '',
    variantThemeId: '',
    theme: {
      name: '',
      themeId: '',
      marketingData: [],
    },
  });

  const handleCardClick = (card: GalleryECard) => {
    analytics.segment.sendTelemetryEvent('galleryDesignClicked', { label: card.title, value: card.title });
    setCardDetails(card);
    setCardDetailModalToggle(true);
  };

  const handleCloseModal = () => {
    setCardDetailModalToggle(false);
  };

  return (
    <GridWrapper>
      <StyledECardColumns multiline>
        {cards.map((card, index) => {
          card.productType = cardDetails.productType;
          return (
            <StyledECardColumn tablet={'six'} desktop={'four'} mobile={card.productType === designs ? 'full' : 'half'} key={index}>
              <GalleryECardCell index={index} card={card} onCardClick={handleCardClick} />
            </StyledECardColumn>
          );
        })}
      </StyledECardColumns>
      {isDisplayCardDetails && !cardDetails.isPhotoECards && (
        <GalleryECardModal
          productType={productType}
          handleClose={handleCloseModal}
          cardDetails={cardDetails}
          isModalOpen={isDisplayCardDetails}
        />
      )}
      {isDisplayCardDetails && cardDetails.isPhotoECards && (
        <PhotoECardModal
          productType={productType}
          handleClose={handleCloseModal}
          cardDetails={cardDetails}
          isModalOpen={isDisplayCardDetails}
        />
      )}
    </GridWrapper>
  );
};
